import { useEffect, useRef } from 'react';

export function useIsUnmounted() {
  const isUnmountedRef = useRef(false);
  useEffect(() => () => void (isUnmountedRef.current = true), []);
  return () => isUnmountedRef.current;
}
